import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import {
  adminUpdateCourseHoursRange,
  getCourseHoursRangeAsAdmin,
} from './adminApi';
import { getCourseHoursRange } from './api';
import { RootState } from '../..';

export interface ICourseHoursRange {
  _id: string;
  minValue: number;
  maxValue: number;
  createdAt: string;
  updatedAt: string;
}

export interface IInitialCourseHoursRangeState {
  status: 'idle' | 'loading' | 'rejected';
  adminCourseHoursRange?: ICourseHoursRange;
  courseHoursRange?: ICourseHoursRange;
}

const initialState: IInitialCourseHoursRangeState = {
  status: 'idle',
  adminCourseHoursRange: undefined,
  courseHoursRange: undefined,
};

export const CourseHoursRangeState = createSlice({
  name: 'courseHoursRange',
  initialState,
  reducers: {
    resetAdminCourseHoursRangesData: (state) => {
      state.adminCourseHoursRange = undefined;
    },
    resetCourseHoursRange: (state) => {
      state.courseHoursRange = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCourseHoursRangeAsAdmin.fulfilled, (state, action) => {
        state.status = 'idle';
        state.adminCourseHoursRange = action.payload;
      })
      .addCase(adminUpdateCourseHoursRange.fulfilled, (state, action) => {
        state.status = 'idle';

        state.adminCourseHoursRange = action.payload;
      })
      .addCase(getCourseHoursRange.fulfilled, (state, action) => {
        state.status = 'idle';
        state.courseHoursRange = action.payload;
      });

    builder.addMatcher(
      isPending(
        getCourseHoursRangeAsAdmin,
        adminUpdateCourseHoursRange,
        getCourseHoursRange
      ),
      (state) => {
        state.status = 'loading';
      }
    );

    builder.addMatcher(
      isRejected(
        getCourseHoursRangeAsAdmin,
        adminUpdateCourseHoursRange,
        getCourseHoursRange
      ),
      (state) => {
        state.status = 'rejected';
      }
    );
  },
});

export const {
  resetAdminCourseHoursRangesData,
  resetCourseHoursRange,
} = CourseHoursRangeState.actions;

export const getCourseHoursRangeState = (
  state: RootState
): RootState['courseHoursRange'] => state.courseHoursRange;

export * from './adminApi';
export * from './api';
export default CourseHoursRangeState.reducer;
